import { render, staticRenderFns } from "./CommunicationPath.vue?vue&type=template&id=b61ecc90&"
import script from "./CommunicationPath.vue?vue&type=script&lang=js&"
export * from "./CommunicationPath.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationPath.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports